const GET_ALL_SUBSCRIPTION_LOADING = 'subscribe/GET_ALL_SUBSCRIPTION_LOADING'
const GET_ALL_SUBSCRIPTION_SUCCESS = 'subscribe/GET_ALL_SUBSCRIPTION_SUCCESS'
const GET_ALL_SUBSCRIPTION_ERROR = 'subscribe/GET_ALL_SUBSCRIPTION_ERROR'

const GET_BANNER_SUBSCRIBEPAGE_LOADING = 'subscribe/GET_BANNER_SUBSCRIBEPAGE_LOADING'
const GET_BANNER_SUBSCRIBEPAGE_SUCCESS = 'subscribe/GET_BANNER_SUBSCRIBEPAGE_SUCCESS'
const GET_BANNER_SUBSCRIBEPAGE_ERROR = 'subscribe/GET_BANNER_SUBSCRIBEPAGE_ERROR'

export { 
  GET_ALL_SUBSCRIPTION_LOADING,
  GET_ALL_SUBSCRIPTION_SUCCESS,
  GET_ALL_SUBSCRIPTION_ERROR,
  GET_BANNER_SUBSCRIBEPAGE_LOADING,
  GET_BANNER_SUBSCRIBEPAGE_SUCCESS,
  GET_BANNER_SUBSCRIBEPAGE_ERROR,
}
